export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'MM/DD/yyyy',
  },
  display: {
    dateInput: 'MM/DD/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};
